<template>
   <div class="region-select-wrapper row">
      <region-select-input
         titleEnglish="Layer View"
         titleNepali="राष्ट्रिय"
         :languageIsEnglish="languageIsEnglish"
         v-model="nationalCode"
         :regions="nationalLevelDivisions"
         @input="selectNationalDivision"
      />
      <region-select-input
         titleEnglish="Province"
         titleNepali="प्रदेश"
         :languageIsEnglish="languageIsEnglish"
         v-model="scode"
         :regions="states"
         @input="selectState"
      />
      <region-select-input
         titleEnglish="District"
         titleNepali="जिल्ला"
         :languageIsEnglish="languageIsEnglish"
         v-model="dcode"
         :regions="districts"
         @input="selectDistrict"
      />
      <region-select-input
         titleEnglish="Municipality"
         titleNepali="पालिका"
         :languageIsEnglish="languageIsEnglish"
         v-model="sddmmcode"
         :regions="municipalities"
         @input="selectMunicipality"
      />
      <div class="ol-unselectable ol-control added reset-selection">
         <button
            title="Reset selection"
            @click="resetSelection()"
            >
            <img src="../../assets/icons/reset.svg">
         </button>
      </div>
   </div>
</template>

<script>
import RegionSelectInput from './RegionSelectInput';
import { getNavigator } from '../../js/mapNavigator/index';
import { bus } from '../../main';

const noneSelectValues = [{titleEnglish: "--", titleNepali: "--", code: -1}];

const nationalLevelDivisions = [
   { titleEnglish: "Provinces",      titleNepali: "प्रदेशहरु",   code: 0    },
   { titleEnglish: "Districts",      titleNepali: "जिल्लाहरु",   code: '00' },
   { titleEnglish: "Municipalities", titleNepali: "पालिकाहरु",  code: '000' },
   ...noneSelectValues,
];

const states = [
   { titleEnglish: "Provinces",    titleNepali: "प्रदेशहरु",        code: 0 },
   { titleEnglish: "Province 1",   titleNepali: "प्रदेश १",        code: 1 },
   { titleEnglish: "Province 2",   titleNepali: "प्रदेश २",        code: 2 },
   { titleEnglish: "Bagmati",      titleNepali: "बाग्मती प्रदेश",     code: 3 },
   { titleEnglish: "Gandaki",      titleNepali: "गण्डकी प्रदेश",     code: 4 },
   { titleEnglish: "Lumbini",      titleNepali: "लुम्बिनी प्रदेश",     code: 5 },
   { titleEnglish: "Karnali",      titleNepali: "कर्णाली प्रदेश",     code: 6 },
   { titleEnglish: "Sudurpaschim", titleNepali: "सुदुर पश्चिम प्रदेश",  code: 7 },
   ...noneSelectValues,
];


export default {
   components: {
      "region-select-input": RegionSelectInput,
   },
   props: {
      languageIsEnglish: { type: Boolean, required: true},
   },
   data() {
      return {
         nationalLevelDivisions: nationalLevelDivisions, 
         states: states,
         districts: noneSelectValues,
         municipalities: noneSelectValues,
         nationalCode: 0,
         scode: -1,
         dcode: -1,
         sddmmcode: -1,
      }
   },
   mounted()
   {
      bus.$on("navigator-initialized", navigator => 
      {
         const showModal = () => bus.$emit('show-loading-modal');
         const hideModal = () => bus.$emit('hide-loading-modal');

         (navigator.country.beforeSelect = navigator.state.beforeSelect = 
         navigator.district.beforeSelect = navigator.municipality.beforeSelect = showModal);
         
         navigator.country.afterSelect = async code => 
         {
            if (code===0||code==='0')
            {
               this.scode=0;
               this.dcode=-1;
               this.sddmmcode=-1;
            }
            else if (code==='00'){
               this.scode=-1;
               this.dcode=0;
               this.sddmmcode=-1;
            }
            else if (code==='000')
            {
               this.scode=-1;
               this.dcode=-1;
               this.sddmmcode=0
            }
            this.districts = await navigator.district.getSelectionOptions();
            this.municipalities = await navigator.municipality.getSelectionOptions();
            hideModal();
         };
         
         navigator.state.afterSelect = async scode =>
         {
            if (scode==='0000') // all muni in current state
            {
               this.dcode = -1;
               this.sddmmcode = 0;
            }
            else
            {
               this.scode = scode;
               this.dcode = 0;  // code for all 0
               this.sddmmcode = -1; // for none
            }
            this.nationalCode = -1;
            this.districts = await navigator.district.getSelectionOptions();
            this.municipalities = await navigator.municipality.getSelectionOptions();
            hideModal();
         };
         navigator.district.afterSelect = async dcode =>
         {
            this.nationalCode = -1;
            this.dcode = dcode;
            this.municipalities = await navigator.municipality.getSelectionOptions();
            this.sddmmcode = 0; // code for all 0
            hideModal();
         };
         navigator.municipality.afterSelect = async sddmm =>
         {
            this.nationalCode = -1;
            this.sddmmcode = sddmm;
            hideModal();
         }
      });
      setTimeout(() => this.selectNationalDivision(0), 1000);
   },
   methods: {
      resetSelection()
      {
         this.selectNationalDivision(0, true);
      },
      selectNationalDivision(nationalCode, reselect=true)
      {
         // update scode when updating nationalcode redesign this better later so it makes more sense
         getNavigator().country.select(nationalCode, {reselect});
      },
      selectState(scode)
      {
         getNavigator().state.select(scode);
      },
      selectDistrict(dcode)
      {
         getNavigator().district.select(dcode);
      },
      selectMunicipality(sddmmcode)
      {
         getNavigator().municipality.select(sddmmcode);
      }
   }
}
</script>

<style lang="scss" scoped>
.region-select-wrapper {
   position: absolute;
   margin-left: 2em;
   width: calc(100% - 2em);
   display: flex;
   justify-content: center;
   align-items: flex-end;
   // left: 0%;
   top: 0.1em;
   // transform: translate(-50%, -0%) !important;
   z-index: 1;
}

.reset-selection {
   position: relative;
   margin-bottom: 2px;// top: 10px;
   box-shadow: inset 0 0 1px rgb(136, 136, 136);
   background: whitesmoke !important;
   height: 29px;
   border: solid 1px lightgrey;
   button {
      background: transparent !important;
   }
}

</style>